function thunkMiddleware({ dispatch, getState }) {
  return next => action => (typeof action === 'function' ? action(dispatch, getState) : next(action));
}

module.exports = thunkMiddleware;
